import { authEndpoint, getAuthInfo, getWebsiteUrl } from "./endpoint";

export const getOAuth2Tokens = (authorizationCode, codeVerifier, onSuccess, onError) => {
    const myInit = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            'grant_type': 'authorization_code',
            'client_id': getAuthInfo().client_id,
            'code': authorizationCode,
            'redirect_uri': getWebsiteUrl(),
            'code_verifier': codeVerifier
        })
    };

    const myRequest = new Request(authEndpoint.tokenPath(), myInit);

    fetch(myRequest)
        .then((res) => {
            res.json()
                .then((data) => {
                    onSuccess(data);
                });
        })
        .catch((error) => {
            onError(null, error);
        });
}

export const getOAuth2UserInfo = (accessToken, onSuccess, onError) => {
    const myInit = {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + accessToken
        }
    };

    const myRequest = new Request(authEndpoint.userInfoPath(), myInit);

    fetch(myRequest)
    .then((res) => {
        res.json()
            .then((data) => {
                onSuccess(data);
            });
    })
    .catch((error) => {
        onError(null, error);
    });
}

